import { Create, SimpleForm, TextInput, required } from 'react-admin';

export const FailureCauseCreate = () => (
  <Create redirect="list">
    <SimpleForm>
      <TextInput source="name" validate={required()} fullWidth />
      <TextInput source="description" multiline rows={3} fullWidth />
    </SimpleForm>
  </Create>
);
